const actions = {
  SET_STATE: 'appointments/SET_STATE',
  GET_APPOINTMENT_LIST: 'appointments/GET_APPOINTMENT_LIST',
  DELETE_APPOINTMENT: 'appointments/DELETE_APPOINTMENT',
  EDIT_APPOINTMENT: 'appointments/EDIT_APPOINTMENT',
  CREATE_APPOINTMENT: 'appointments/CREATE_APPOINTMENT',
  APPEND_APPOINTMENT_LIST: 'appointments/APPEND_APPOINTMENT_LIST',
  UPDATE_APPOINTMENT_LIST: 'appointments/UPDATE_APPOINTMENT_LIST',
  GET_APPOINTMENT_THERAPIST: 'appointments/GET_APPOINTMENT_THERAPIST',
  GET_APPOINTMENT_LEARNER: 'appointments/GET_APPOINTMENT_LEARNER',
  GET_APPOINTMENT: 'appointments/GET_APPOINTMENT',
}

export default actions
